import { render, staticRenderFns } from "./loading_2.vue?vue&type=template&id=ebb12e98&scoped=true&"
import script from "./loading_2.vue?vue&type=script&lang=js&"
export * from "./loading_2.vue?vue&type=script&lang=js&"
import style0 from "./loading_2.vue?vue&type=style&index=0&id=ebb12e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb12e98",
  null
  
)

export default component.exports